<template>
  <div v-if="permissoes.editar_configuracoes || permissoes.ler_configuracoes">
    <!-- Breadcrumb e Cabeçalho -->
    <el-row class="el-row-topo">
      <el-col :span="24">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item :to="{ path: '/' }">Home</el-breadcrumb-item>
          <el-breadcrumb-item>Configurações 2</el-breadcrumb-item>
        </el-breadcrumb>
      </el-col>
    </el-row>
    <!-- Título -->
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <h1>Configurações 2</h1>
      </el-col>
    </el-row>
  
      <el-form 
        :model="configuracoes" 
        :rules="rules" 
        ref="formConfiguracoes" 
        label-position="right"
        label-width="250px"
      >
        <el-form-item label="Nome" prop="nome">
          <el-input v-model="configuracoes.nome" />
        </el-form-item>
        <el-form-item label="Logradouro" prop="logradouro">
          <el-input v-model="configuracoes.logradouro" />
        </el-form-item>
        <el-form-item label="Cidade" prop="cidade">
          <el-input v-model="configuracoes.cidade" />
        </el-form-item>
        <el-form-item label="UF" prop="uf">
          <el-input v-model="configuracoes.uf" />
        </el-form-item>
        <el-form-item label="CEP" prop="cep">
          <el-input v-model="configuracoes.cep" />
        </el-form-item>
        <el-form-item label="Telefone" prop="telefone"> 
          <el-input v-model="configuracoes.telefone" />
        </el-form-item>
        <el-form-item label="Whatsapp" prop="whatsapp">
          <el-input v-model="configuracoes.whatsapp" />
        </el-form-item>
        <el-form-item label="Site" prop="site">
          <el-input v-model="configuracoes.site" />
        </el-form-item>
        <el-form-item label="Email" prop="email">
          <el-input v-model="configuracoes.email" />
        </el-form-item>
        <el-form-item label="PIS" prop="pis">
          <el-input v-model="configuracoes.pis" />
        </el-form-item>
        <el-form-item label="COFINS" prop="cofins">
          <el-input v-model="configuracoes.cofins" />
        </el-form-item>
        <el-form-item label="IBS" prop="ibs">
          <el-input v-model="configuracoes.ibs" />
        </el-form-item>

        <el-form-item label="CBS" prop="cbs">
          <el-input v-model="configuracoes.cbs" />
        </el-form-item>
        <el-form-item label="IRPJ" prop="irpj">
          <el-input v-model="configuracoes.irpj" />
        </el-form-item>
        <el-form-item label="CSLL" prop="csll">
          <el-input v-model="configuracoes.csll" />
        </el-form-item>
        <el-form-item label="Fator Comissao Gerente Encargos" prop="fator_comissao_gerente_encargos">
          <el-input v-model="configuracoes.fator_comissao_gerente_encargos" />
        </el-form-item>
        <el-form-item label="Fator Comissao Interna Encargos" prop="fator_comissao_interna_encargos">
          <el-input v-model="configuracoes.fator_comissao_interna_encargos" />
        </el-form-item>
        <el-form-item label="Fator Comissao Externa Encargos" prop="fator_comissao_externa_encargos">
          <el-input v-model="configuracoes.fator_comissao_externa_encargos" />
        </el-form-item>
        <el-form-item label="Fator Indicador Externo Encargos" prop="fator_indicador_externo_encargos"> 
          <el-input v-model="configuracoes.fator_indicador_externo_encargos" />
        </el-form-item>
        <el-form-item label="Desconto IPI" prop="ipi_desconto">
          <el-input v-model="configuracoes.ipi_desconto" />
        </el-form-item>
        <el-form-item label="Desconto ICMS Fabricante RS" prop="fabricante_rs">
          <el-input v-model="configuracoes.fabricante_rs" />
        </el-form-item>
        <el-form-item label="Percentual Mão de Obra 2" prop="percentual_mo_2">
          <el-input v-model="configuracoes.percentual_mo_2" />
        </el-form-item>
        <el-form-item label="Faturamento Direto" prop="faturamento_direto">
          <el-input v-model="configuracoes.faturamento_direto" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 1 Nome" prop="contato_engenharia_1_nome">
          <el-input v-model="configuracoes.contato_engenharia_1_nome" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 1 Email" prop="contato_engenharia_1_email">
          <el-input v-model="configuracoes.contato_engenharia_1_email" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 1 Telefone" prop="contato_engenharia_1_telefone">
          <el-input v-model="configuracoes.contato_engenharia_1_telefone" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 2 Nome" prop="contato_engenharia_2_nome">
          <el-input v-model="configuracoes.contato_engenharia_2_nome" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 2 Email" prop="contato_engenharia_2_email">
          <el-input v-model="configuracoes.contato_engenharia_2_email" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 2 Telefone" prop="contato_engenharia_2_telefone">
          <el-input v-model="configuracoes.contato_engenharia_2_telefone" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 3 Nome" prop="contato_engenharia_3_nome">
          <el-input v-model="configuracoes.contato_engenharia_3_nome" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 3 Email" prop="contato_engenharia_3_email">
          <el-input v-model="configuracoes.contato_engenharia_3_email" />
        </el-form-item>
        <el-form-item label="Contato Engenharia 3 Telefone" prop="contato_engenharia_3_telefone">
          <el-input v-model="configuracoes.contato_engenharia_3_telefone" />
        </el-form-item>
        <el-form-item label="NBRTEC Aceite Nome" prop="nbrtec_aceite_nome">
          <el-input v-model="configuracoes.nbrtec_aceite_nome" />
        </el-form-item>
        <el-form-item label="NBRTEC Aceite Cargo" prop="nbrtec_aceite_cargo">
          <el-input v-model="configuracoes.nbrtec_aceite_cargo" />
        </el-form-item>
        <el-form-item label="NBRTEC Aceite Email" prop="nbrtec_aceite_email">
          <el-input v-model="configuracoes.nbrtec_aceite_email" />
        </el-form-item>
        <el-form-item label="Proposta Validade" prop="proposta_validade">
          <el-input v-model="configuracoes.proposta_validade" />
        </el-form-item>
        <el-form-item label="Garantia" prop="garantia">
          <el-input v-model="configuracoes.garantia" />
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button @click="formConfiguracoesClose()">Cancelar</el-button> -->
        <el-button type="primary" @click="submitConfiguracoes()">Salvar</el-button>
      </span>

  </div>
</template>
<script>

import axios from "axios";
import FuncoesUteis from "../plugins/FuncoesUteis";

const url = "/api";

export default {

  data() {
    return {
      loading: true,
      formConfiguracoesVisible: false,
      permissoes: {},
      configuracoes: [],
      formDataConfiguracoes: {},
      rules: {
        nome: [
          { required: true, message: "Por Favor, informe o Nome da Empresa", trigger: "blur" },
        ],
        email: [
          { required: true, message: "Por Favor, informe o Email da Empresa", trigger: "blur" },
          { type: 'email', message: 'Por Favor, informe um email válido', trigger: 'blur' },
        ],
      },
    };
  },

  mounted() {
    this.permissoes = FuncoesUteis.isPermissao();
    if (!this.permissoes.editar_configuracoes && !this.permissoes.ler_configuracoes) {
      this.$message.error("Você não tem permissão para acessar esta página.");
      this.$router.push("/");
      return;
    }
    this.buscarConfiguracoes();
  },

  methods: {

    async buscarConfiguracoes() {
      try {
        this.loading = true;
        const response = await axios.get(url + '/orcamento/negocio/configuracoes-2/1', {
          headers: { Authorization: "Bearer " + this.$store.state.token },
        });
        if (response.data.status === "Token is Expired") {
          await this.$store.dispatch("logout");
          this.$router.push("/login");
        } else {
          // console.log('Data Configuracoes ', response.data);
          this.configuracoes = response.data;
        }
      } catch (error) {
        this.$message.error('Erro ao buscar Configurações: ' + error.message);
      } finally {
        this.loading = false;
      }
    },

    formConfiguracoesOpen(row = null) {
      if (row) {
        this.configuracoes = { ...row };
      } else {
          this.configuracoes = { 
            id: null,
            nome: null,
            logradouro: null,
            cidade: null,
            uf: null,
            cep: null,
            telefone: null,
            whatsapp: null,
            site: null,
            email: null,
            pis: null,
            cofins: null,
            ibs: null,
            cbs: null,
            irpj: null,
            csll: null,
            fator_comissao_gerente_encargos: null,
            fator_comissao_interna_encargos: null,
            fator_comissao_externa_encargos: null,
            fator_indicador_externo_encargos: null,
            ipi_desconto: null,
            fabricante_rs: null,
            percentual_mo_2: null, 
            faturamento_direto: null,
            contato_engenharia_1_nome: null,
            contato_engenharia_1_email: null,
            contato_engenharia_1_telefone: null,
            contato_engenharia_2_nome: null,
            contato_engenharia_2_email: null,
            contato_engenharia_2_telefone: null,
            contato_engenharia_3_nome: null,
            contato_engenharia_3_email: null,
            contato_engenharia_3_telefone: null,
            nbrtec_aceite_nome: null,
            nbrtec_aceite_cargo: null,
            nbrtec_aceite_email: null,
            proposta_validade: null,
            garantia: null
          };
      }
      this.formConfiguracoesVisible = true;
    },

    formConfiguracoesClose() {
      this.$confirm("Deseja fechar sem salvar?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.formConfiguracoesVisible = false;
        })
        .catch(() => {});
    },

    submitConfiguracoes() {
      this.$refs.formConfiguracoes.validate((valid) => {
        if (!valid) {
          this.$message.info("Preencha os dados corretamente!");
          return;
        }

        const headers = { Authorization: "Bearer " + this.$store.state.token };
        const payload = { ...this.configuracoes };
        const request = axios.put(`${url}/orcamento/negocio/configuracoes-2/${this.configuracoes.id}`, payload, { headers });

        request
          .then(() => {
            this.$notify({
              title: "Sucesso",
              message: "Registro atualizado!",
              type: "success",
            });
            this.formConfiguracoesVisible = false;
            this.buscarConfiguracoes();
          })
          .catch((err) => {
            this.$notify({
              title: "Erro",
              message: "Falha ao salvar os dados. " + err,
              type: "error",
            });
          });
      });
    },


  },

};

</script>

<style scoped>
</style>
